import { clearAuthStorage } from '../utils/authSession';

const ONBOARDING_STORAGE_PREFIX = 'luckynote_tour_';

export const clearLocalStoragePreservingOnboarding = () => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return;
    }

    const preservedValues = {};

    try {
        for (let index = 0; index < window.localStorage.length; index += 1) {
            const key = window.localStorage.key(index);
            if (key && (key.startsWith(ONBOARDING_STORAGE_PREFIX) || key === 'luckynote.product-language.v1')) {
                preservedValues[key] = window.localStorage.getItem(key);
            }
        }

        clearAuthStorage();

        Object.entries(preservedValues).forEach(([key, value]) => {
            if (value != null) {
                window.localStorage.setItem(key, value);
            }
        });
    } catch (_error) {
        clearAuthStorage();
    }
};
